function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { wrapDisplayName } from './utils';
/**
 * A function that returns a React HOC that modifies a component's props using a given function.
 *
 * The provided function will be called with the component's props,
 * and should return an object that will be merged with those props.
 *
 * @name modifyProps
 * @type Function
 * @param {Function} modFunction - A function that modifies the component's props.
 * @returns {Function} - A HOC that can be used to wrap a component.
 *
 * @example
 *
 * // modifyProps is used to create a custom save function by combining
 * // props from mapStateToProps() and mapDispatchToProps()
 *
 * function SaveableProfile ({ name, save }) {
 *   return (
 *     <div>
 *       <h1>{ name }</h1>
 *       <button onClick={ save }>
 *         Save this profile
 *       </button>
 *     </div>
 *   )
 * }
 *
 * function mapStateToProps (state) {
 *    return {
 *       id: selectors.profileId(state)
 *    }
 * }
 * 
 * const mapDispatchToProps = { 
 *    saveProfile: actions.saveProfile
 * }
 *
 * function modify ({ id, saveProfile }) {
 *    return {
 *       save: () => saveProfile(id)
 *    }
 * }
 * 
 * export default compose(
 *    connect(mapStateToProps, mapDispatchToProps),
 *    modifyProps(modify),
 * )(SaveableProfile)
 *
*/
// Check whether modFunction exists and is a function

var isValid = function isValid(modFunction) {
  return !!modFunction && typeof modFunction === 'function';
};

export default function modifyProps(modFunction) {
  if (!isValid(modFunction)) throw new Error('modifyProps requires a valid modFunction argument.');
  return function (WrappedComponent) {
    function Wrapper(props) {
      var newProps = _objectSpread({}, props, {}, modFunction(props));

      return React.createElement(WrappedComponent, newProps);
    }

    Wrapper.displayName = wrapDisplayName(WrappedComponent, 'modifyProps');
    return Wrapper;
  };
}